import createTheme from './createTheme'

export default createTheme({
  colors: {
    main: '#EC6906',
    main90: '#ee8b3f',
    main80: '#EF8737',
    main70: '#eF8F4F',
    main60: '#F7C39B',
    main50: '#FFCF9F',
    main40: '#F7C39B',
    main30: '#FFCF9F',
    main20: '#FBE1CD',
    main10: '#FFE4CF',

    darkMain: '#572502',
    darkMain90: '#5F2F0F',
    darkMain80: '#785034',
    darkMain70: '#7F5F3F',
    darkMain60: '#9A7C67',
    darkMain50: '#9F7F6F',
    darkMain40: '#BBA799',
    darkMain30: '#BFAF9F',
    darkMain20: '#DDD3CC',
    darkMain10: '#DFD8DE',

    accent: '#A9F4D4',
    accent90: '#AAF8D9',
    accent80: '#BAF6DC',
    accent70: '#BFFFDF',
    accent60: '#CBF8E5',
    accent50: '#CFFFEF',
    accent40: '#DCFAED',
    accent30: '#DFFFEF',
    accent20: '#EDFCF6',
    accent10: '#EFFFFF',
    accent_dark: '#80cfac',

    gray: '#555759',
    gray90: '#66686A',
    gray80: '#77787A',
    gray70: '#88888A',
    gray60: '#999A9B',
    gray50: '#AAAAAB',
    gray40: '#BBBBBC',
    gray30: '#CCCCCC',
    gray20: '#DDDDDD',

    focusColor: '#005eca',
  },
})
